import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { DataProvider } from "./context/DataContext";
import AppRoutes from "routes/AppRoutes";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <DataProvider>
    <AppRoutes />
  </DataProvider>
);
